import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Trainee Selection for Stipend")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "heading" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { class: "text-center mt-5" }, "Eligible Trainee(s) for Stipend", -1)
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = {
  key: 0,
  class: "row"
}
const _hoisted_10 = { class: "col-12 text-center mt-5" }
const _hoisted_11 = ["data-kt-indicator"]
const _hoisted_12 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_13 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_14 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_16 = { class: "collapse show" }
const _hoisted_17 = { class: "card-body border-top p-4" }
const _hoisted_18 = {
  key: 0,
  class: "card mb-5 mt-5 mb-xl-10"
}
const _hoisted_19 = {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_20 = { class: "row mt-1 w-100 m-0" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "div pb-2" }
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-6 mt-1 text-end\" data-v-54b12dc8=\"\"><button type=\"button\" class=\"btn btn-dark fs-7 p-2 rounded-0\" title=\"Download Xlse\" data-v-54b12dc8=\"\"><i class=\"fas fa-file-excel fs-5\" data-v-54b12dc8=\"\"></i> Excel </button><button type=\"button\" class=\"btn btn-warning fs-7 p-2 rounded-0\" title=\"Download PDF\" data-v-54b12dc8=\"\"><i class=\"fas fa-file-pdf fs-5\" data-v-54b12dc8=\"\"></i> PDF </button><button type=\"button\" class=\"btn btn-primary fs-7 p-2 rounded-0\" title=\"Download CSV\" data-v-54b12dc8=\"\"><i class=\"fas fa-file-csv fs-5\" data-v-54b12dc8=\"\"></i> CSV </button></div>", 1)
const _hoisted_24 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_25 = { class: "collapse show" }
const _hoisted_26 = { class: "card-body border-top p-6" }
const _hoisted_27 = { class: "row w-100 mb-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_29 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_37 = { class: "row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("h5", _hoisted_6, _toDisplayString(this.entity_id == '-1' || -1
              ? ''
              : this.traineeList[0]?.entity_short_name), 1),
        _createElementVNode("h6", _hoisted_7, _toDisplayString(this.traineeList[0]?.institute_name), 1),
        _createElementVNode("h6", _hoisted_8, " Start Date : " + _toDisplayString(this.start_date) + " | End Date : " + _toDisplayString(this.end_date) + " | | Total Records : " + _toDisplayString(this.traineeList.length), 1)
      ])), [
        [_directive_loading, _ctx.load]
      ]),
      (_ctx.showselectbtn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                "data-kt-indicator": _ctx.loading ? 'on' : null,
                class: "btn btn-sm btn-success ml-3 p-3",
                title: "select stipend",
                style: {"padding-top":"8px !important","padding-bottom":"8px !important"},
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.formSubmit()))
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      _createTextVNode(" Select for Stipend "),
                      _createElementVNode("span", _hoisted_13, [
                        _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                      _createTextVNode(" Please wait... "),
                      _hoisted_15
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_11)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          (_ctx.showdetails)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control ps-10 w-200px mt-1 form-control-sm",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchItems())),
                          style: {"height":"1em"},
                          placeholder: "Search"
                        }, null, 544), [
                          [_vModelText, _ctx.search]
                        ])
                      ])
                    ]),
                    _hoisted_23
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                            title: "Download Xlse",
                            "data-v-54b12dc8": "",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.exportTrainee()))
                          }, _hoisted_31),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                            title: "Download PDF",
                            "data-v-54b12dc8": "",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadPdf()))
                          }, _hoisted_33),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                            title: "Print",
                            "data-v-54b12dc8": "",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.printPdf()))
                          }, _hoisted_35)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                          _createVNode(_component_Datatable, {
                            "table-data": _ctx.traineeList,
                            "table-header": _ctx.tableHeader,
                            "enable-items-per-page-dropdown": true
                          }, {
                            "cell-sl": _withCtx(({ row }) => [
                              _createTextVNode(_toDisplayString(row.sl), 1)
                            ]),
                            "cell-association": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.entity_short_name), 1)
                            ]),
                            "cell-institute": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.institute_name), 1)
                            ]),
                            "cell-course": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.course_name), 1)
                            ]),
                            "cell-batch": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.batch_number), 1)
                            ]),
                            "cell-start": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.start_date
                              ? _ctx.moment(traineeList?.start_date).format(
                                  'DD-MM-YYYY'
                                )
                              : ''), 1)
                            ]),
                            "cell-end": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.end_date
                              ? _ctx.moment(traineeList?.end_date).format(
                                  'DD-MM-YYYY'
                                )
                              : ''), 1)
                            ]),
                            "cell-trainee": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.trainee_name), 1)
                            ]),
                            "cell-registration_number": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.registration_number), 1)
                            ]),
                            "cell-ref_num": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.reference_number), 1)
                            ]),
                            "cell-account_type": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.account_type), 1)
                            ]),
                            "cell-bank_detail": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.bank_detail), 1)
                            ]),
                            "cell-acc_number": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.bank_account_number), 1)
                            ]),
                            "cell-father_name": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.father_name), 1)
                            ]),
                            "cell-Mother_name": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.mother_name), 1)
                            ]),
                            "cell-mobile": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.mobile), 1)
                            ]),
                            "cell-gender": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.gender), 1)
                            ]),
                            "cell-per_address": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.per_address), 1)
                            ]),
                            "cell-income": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.income !== null && traineeList?.income !== undefined ? traineeList.income.toFixed(2) : ''), 1)
                            ]),
                            "cell-postcode": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.per_post_code), 1)
                            ]),
                            "cell-upazilla": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.per_upazilla), 1)
                            ]),
                            "cell-home_district": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.home_district), 1)
                            ]),
                            "cell-attendance_percentage": _withCtx(({
                            row: traineeList,
                          }) => [
                              _createTextVNode(_toDisplayString(traineeList?.attendance_percentage), 1)
                            ]),
                            "cell-ethnic": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.ethnic_group), 1)
                            ]),
                            "cell-physically_disabled": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.is_physically_challenged), 1)
                            ]),
                            "cell-income_certificate": _withCtx(({ row: traineeList }) => [
                              _createTextVNode(_toDisplayString(traineeList?.income_certificate == '1'
                              ? 'Yes'
                              : 'No'), 1)
                            ]),
                            _: 1
                          }, 8, ["table-data", "table-header"])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}